import { COVER_LETTER_INIT_SUCCESS, COVER_LETTER_INIT_FAIL, COVER_LETTER_INIT_LOADING, CANCELLTR_INIT_LOADING, CANCELLTR_INIT_SUCCESS, CANCELLTR_INIT_FAIL,
  PAYTSTATLTR_INIT_LOADING, PAYTSTATLTR_INIT_SUCCESS, PAYTSTATLTR_INIT_FAIL, PAYTSTATLTR_COMMIT_KEY } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import clone from 'clone'

const initialState = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  cancelLtr: {
    init: 0,
    initErr: [],
    menu: {}
  },
  paytStatLtr: {
    tranMode: null,
    bankRef: null,
    paytMeth: null,
    paytStat: null
  }
}

const getters = {

}

const mutations = {
  [COVER_LETTER_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [COVER_LETTER_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [COVER_LETTER_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [CANCELLTR_INIT_LOADING](state) {
    state.cancelLtr.init = 0
    state.cancelLtr.menu = {}
    state.cancelLtr.initErr = []
  },
  [CANCELLTR_INIT_SUCCESS](state, data) {
    state.cancelLtr.init = 1
    state.cancelLtr.menu = data ? data.menu : null
    state.cancelLtr.initErr = []
  },
  [CANCELLTR_INIT_FAIL](state, err) {
    state.cancelLtr.init = 2
    state.cancelLtr.menu = {}
    state.cancelLtr.initErr = err
  },
  [PAYTSTATLTR_INIT_LOADING](state, err) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [PAYTSTATLTR_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [PAYTSTATLTR_INIT_FAIL](state, err) {
    state.init = 2
    state.initErr = err
    state.menu = {}
  },
  [PAYTSTATLTR_COMMIT_KEY](state, data) {
    state.paytStatLtr.tranMode = data.tranMode
    state.paytStatLtr.bankRef = data.bankRef
    state.paytStatLtr.paytStat = data.paytStat
    state.paytStatLtr.paytMeth = data.paytMeth
  }
}

const actions = {
  async coverLetterManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.coverLetterManagement
    commit(COVER_LETTER_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(COVER_LETTER_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(COVER_LETTER_INIT_FAIL, extractMessages(error))
      }
    }
  },
  async cancelLtrInit({ commit, rootState }) {
    const apiUrl = rootState.coverLetterParam.menu.initCancelLtr
    commit(CANCELLTR_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(CANCELLTR_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(CANCELLTR_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
